import React, { useState } from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { Save, RotateCcw, AlertCircle, CheckCircle2, Clock, Heart, Settings } from 'lucide-react';
export function ScoringRulesPage() {
  const [isEditing, setIsEditing] = useState(false);
  // Mock State for Rules
  const [rules, setRules] = useState({
    posting: {
      baseScore: 50,
      onTimeBonus: 20,
      latePenalty: -10,
      validationBonus: 10
    },
    engagement: {
      likeWeight: 1,
      commentWeight: 2,
      shareWeight: 3,
      viewWeight: 0.1,
      maxScore: 30 // Max points from engagement
    },
    thresholds: {
      green: 80,
      yellow: 50
    }
  });
  const handleSave = () => {
    setIsEditing(false);
    // API Call to save rules
  };
  return <CommandCenterLayout title="Konfigurasi Skor Kinerja" subtitle="Atur bobot dan parameter penilaian otomatis untuk daerah" data-id="element-2349">
      <div className="space-y-6 max-w-5xl mx-auto" data-id="element-2350">
        <div className="flex justify-between items-center" data-id="element-2351">
          <div className="flex items-center gap-2 text-yellow-700 bg-yellow-50 px-4 py-2 rounded-lg border border-yellow-200 text-sm" data-id="element-2352">
            <AlertCircle className="h-4 w-4" data-id="element-2353" />
            <span data-id="element-2354">
              Perubahan aturan skor akan mempengaruhi perhitungan campaign yang
              sedang berjalan.
            </span>
          </div>
          <div className="flex gap-2" data-id="element-2355">
            {isEditing ? <>
                <Button variant="ghost" onClick={() => setIsEditing(false)} data-id="element-2356">
                  Batal
                </Button>
                <Button onClick={handleSave} className="gap-2" data-id="element-2357">
                  <Save className="h-4 w-4" data-id="element-2358" /> Simpan Perubahan
                </Button>
              </> : <Button onClick={() => setIsEditing(true)} variant="outline" className="gap-2" data-id="element-2359">
                <Settings className="h-4 w-4" data-id="element-2360" /> Edit Konfigurasi
              </Button>}
          </div>
        </div>

        {/* Posting Score Rules */}
        <Card data-id="element-2361">
          <CardHeader data-id="element-2362">
            <div className="flex items-center gap-3" data-id="element-2363">
              <div className="p-2 bg-blue-100 rounded-lg text-blue-600" data-id="element-2364">
                <CheckCircle2 className="h-6 w-6" data-id="element-2365" />
              </div>
              <div data-id="element-2366">
                <CardTitle data-id="element-2367">Skor Dasar Posting</CardTitle>
                <CardDescription data-id="element-2368">
                  Poin yang didapat saat melakukan posting dan validasi
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent className="space-y-6" data-id="element-2369">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2370">
              <div data-id="element-2371">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2372">
                  Base Score (URL Submitted)
                </label>
                <div className="flex items-center gap-2" data-id="element-2373">
                  <Input type="number" value={rules.posting.baseScore} disabled={!isEditing} className="w-32" data-id="element-2374" />
                  <span className="text-sm text-gray-500" data-id="element-2375">poin</span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2376">
                  Diberikan saat link disubmit.
                </p>
              </div>

              <div data-id="element-2377">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2378">
                  Validation Bonus
                </label>
                <div className="flex items-center gap-2" data-id="element-2379">
                  <Input type="number" value={rules.posting.validationBonus} disabled={!isEditing} className="w-32" data-id="element-2380" />
                  <span className="text-sm text-gray-500" data-id="element-2381">poin</span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2382">
                  Tambahan jika lolos validasi admin.
                </p>
              </div>

              <div data-id="element-2383">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2384">
                  On-Time Bonus
                </label>
                <div className="flex items-center gap-2" data-id="element-2385">
                  <Input type="number" value={rules.posting.onTimeBonus} disabled={!isEditing} className="w-32" data-id="element-2386" />
                  <span className="text-sm text-gray-500" data-id="element-2387">poin</span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2388">
                  Jika posting sebelum deadline.
                </p>
              </div>

              <div data-id="element-2389">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2390">
                  Late Penalty
                </label>
                <div className="flex items-center gap-2" data-id="element-2391">
                  <Input type="number" value={rules.posting.latePenalty} disabled={!isEditing} className="w-32 text-red-600" data-id="element-2392" />
                  <span className="text-sm text-gray-500" data-id="element-2393">poin</span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2394">
                  Pengurangan jika lewat deadline.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Engagement Score Rules */}
        <Card data-id="element-2395">
          <CardHeader data-id="element-2396">
            <div className="flex items-center gap-3" data-id="element-2397">
              <div className="p-2 bg-pink-100 rounded-lg text-pink-600" data-id="element-2398">
                <Heart className="h-6 w-6" data-id="element-2399" />
              </div>
              <div data-id="element-2400">
                <CardTitle data-id="element-2401">Bobot Engagement</CardTitle>
                <CardDescription data-id="element-2402">
                  Perhitungan skor berdasarkan interaksi sosial media
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent className="space-y-6" data-id="element-2403">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-2404">
              <div data-id="element-2405">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2406">
                  Like Weight
                </label>
                <Input type="number" step="0.1" value={rules.engagement.likeWeight} disabled={!isEditing} data-id="element-2407" />
              </div>
              <div data-id="element-2408">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2409">
                  Comment Weight
                </label>
                <Input type="number" step="0.1" value={rules.engagement.commentWeight} disabled={!isEditing} data-id="element-2410" />
              </div>
              <div data-id="element-2411">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2412">
                  Share Weight
                </label>
                <Input type="number" step="0.1" value={rules.engagement.shareWeight} disabled={!isEditing} data-id="element-2413" />
              </div>
              <div data-id="element-2414">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2415">
                  View Weight
                </label>
                <Input type="number" step="0.01" value={rules.engagement.viewWeight} disabled={!isEditing} data-id="element-2416" />
              </div>
            </div>

            <div className="border-t pt-4" data-id="element-2417">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2418">
                Max Engagement Score Cap
              </label>
              <div className="flex items-center gap-2" data-id="element-2419">
                <Input type="number" value={rules.engagement.maxScore} disabled={!isEditing} className="w-32" data-id="element-2420" />
                <span className="text-sm text-gray-500" data-id="element-2421">poin maksimal</span>
              </div>
              <p className="text-xs text-gray-500 mt-1" data-id="element-2422">
                Batas maksimal poin engagement agar daerah viral tidak
                mendominasi skor total secara tidak wajar.
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Thresholds */}
        <Card data-id="element-2423">
          <CardHeader data-id="element-2424">
            <div className="flex items-center gap-3" data-id="element-2425">
              <div className="p-2 bg-green-100 rounded-lg text-green-600" data-id="element-2426">
                <TrendingUp className="h-6 w-6" data-id="element-2427" />
              </div>
              <div data-id="element-2428">
                <CardTitle data-id="element-2429">Kategori Status Kinerja</CardTitle>
                <CardDescription data-id="element-2430">
                  Batas nilai untuk status Hijau, Kuning, dan Merah
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent data-id="element-2431">
            <div className="space-y-6" data-id="element-2432">
              <div className="flex items-center gap-4" data-id="element-2433">
                <div className="w-24" data-id="element-2434">
                  <StatusBadge status="hijau" data-id="element-2435">Sangat Baik</StatusBadge>
                </div>
                <span className="text-sm text-gray-600" data-id="element-2436">Skor &ge;</span>
                <Input type="number" value={rules.thresholds.green} disabled={!isEditing} className="w-24" data-id="element-2437" />
              </div>

              <div className="flex items-center gap-4" data-id="element-2438">
                <div className="w-24" data-id="element-2439">
                  <StatusBadge status="kuning" data-id="element-2440">Cukup</StatusBadge>
                </div>
                <span className="text-sm text-gray-600" data-id="element-2441">Skor &ge;</span>
                <Input type="number" value={rules.thresholds.yellow} disabled={!isEditing} className="w-24" data-id="element-2442" />
                <span className="text-sm text-gray-500" data-id="element-2443">
                  (dan &lt; {rules.thresholds.green})
                </span>
              </div>

              <div className="flex items-center gap-4" data-id="element-2444">
                <div className="w-24" data-id="element-2445">
                  <StatusBadge status="merah" data-id="element-2446">Kurang</StatusBadge>
                </div>
                <span className="text-sm text-gray-600" data-id="element-2447">Skor &lt;</span>
                <span className="font-bold text-gray-900" data-id="element-2448">
                  {rules.thresholds.yellow}
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </CommandCenterLayout>;
}